import React from 'react';

const InputErrorMessage = ({children}) => (
    <span className="input-error-message">
        {children}
    </span>
);

export default InputErrorMessage;
